import React, { useRef, useState } from 'react'

import { Box, Chip, Popover, Typography } from '@material-ui/core'
import { Info as InfoIcon } from 'react-feather'

import { Dai } from 'components'

import useStyles from './styles'
import constants from 'constants/index'

const ActivityDisputeDaiButton = ({ onClick, disabled }) => {
  const [open, setOpen] = useState(false)

  const anchorRef = useRef(null)
  const classes = useStyles()

  const { TAGS, GROUP_TAGS } = constants.dai.solutions

  const handleMouseEnter = () => {
    if (!disabled) setOpen(true)
  }

  const handleMouseLeave = () => {
    setOpen(false)
  }

  const handleClick = () => {
    handleMouseLeave()
    onClick()
  }

  return (
    <Box ref={anchorRef}>
      <Dai.Permitted
        tag={[
          GROUP_TAGS.GOVERNANCE_PROJECTS,
          TAGS.GOVERNANCE_PROJECT_DISPUTE_ANALYSIS,
        ]}
      >
        <Dai.StarButton
          size="small"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={handleClick}
          disabled={disabled}
        >
          Contestar com a DAI
        </Dai.StarButton>
      </Dai.Permitted>

      <Popover
        open={open}
        anchorEl={anchorRef.current}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        className={classes.popover}
        classes={{ paper: classes.paper }}
        disableRestoreFocus
        onClose={handleMouseLeave}
        PaperProps={{
          onMouseEnter: handleMouseEnter,
          onMouseLeave: handleMouseLeave,
        }}
      >
        <Box className={classes.header}>
          <InfoIcon size={16} className={classes.infoIcon} />
          <Typography variant="subtitle2" className={classes.title}>
            Funcionalidade em Beta
          </Typography>
          <Chip label="Beta" size="small" className={classes.betaChip} />
        </Box>
        <Typography variant="body2" className={classes.description}>
          A geração de documentos de contestação por Inteligência Artificial
          encontra-se em versão beta. Os documentos gerados possuem caráter{' '}
          <b>apenas indicativo</b> e <b>não substituem</b> a análise jurídica de
          um profissional. Todos os resultados{' '}
          <b>devem ser revisados e validados</b> antes de qualquer uso formal.
        </Typography>
        <Typography variant="caption" display="block" className={classes.note}>
          <b>Nota:</b> Apenas documentos em formato <b>PDF</b> são processados.
        </Typography>
      </Popover>
    </Box>
  )
}

export default ActivityDisputeDaiButton
